<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle>
          <v-btn
            fab
            x-small
            class="warning"
            @click="editItem(item)"
          >
            <i
              class="fal fa-pencil fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="error"
            @click="deleteItem(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-img
                  :src="editedItem.photo"
                  aspect-ratio="1"
                  height="100"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-file-input
                v-model="files"
                counter
                :label="$t('select_files')"
                prepend-icon="mdi-paperclip"
                accept="image/*"
                outlined
                dense
                :show-size="1000"
                class="me-4"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 3"
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                  <v-chip
                    v-else-if="index === 3"
                    label
                    small
                  >
                    +{{ files.length - 3 }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleting(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Category',
    data () {
      return {
        headers: [],
        dataRows: [],
        files: [],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        totalItems: 0,
        tableCPP: 0,
        search: '',
        loading: true,
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        dialog: false,
        formTitle: '',
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
      }
    },
    async created () {
      await this.getQuestionCategories()
      await this.getOptions()
      await this.getHeaders()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Questions-Categories-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x903'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x904'
            this.snackbar = true
          }
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Questions-TH-Category',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({ text: this.$t(o.value), value: o.value })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x905'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x906'
            this.snackbar = true
          }
        })
      },
      getQuestionCategories () {
        this.$http.post('questionCategories/index').then(
          response => {
            this.dataRows = response.data.QuestionCategories
            this.loading = false
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x907'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x908'
            this.snackbar = true
          }
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      deleting (item) {
        this.btnLoadingDelete = true
        this.$http.post('questionCategories/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error) {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x909'
              this.snackbar = true
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x910'
            this.snackbar = true
          }
        })
      },
      save () {
        const formData = new FormData()
        formData.append('id', this.editedItem.id)
        formData.append('file', this.files)
        formData.append('title', this.editedItem.title)
        formData.append('parentId', this.editedItem.parent_id)
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('questionCategories/update', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          }).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error) {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ' | 0x911'
                this.snackbar = true
              }
            }).catch(error => {
            if (error) {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x912'
              this.snackbar = true
            }
          })
        } else {
          this.$http.post('questionCategories/create', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          }).then(
            response => {
              this.dataRows.push(response.data.QuestionCategory)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error) {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ' | 0x913'
                this.snackbar = true
              }
            }).catch(error => {
            if (error) {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x914'
              this.snackbar = true
            }
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.editedIndex = -1
      },
    },
  }
</script>

<style scoped>

</style>
